import { Root } from '@radix-ui/react-separator';
import type { ComponentPropsWithRef } from 'react';
import { cn } from '../lib/cn';

export type SeparatorProps = ComponentPropsWithRef<typeof Root>;

/**
 * A rule. Defaults to `decorative`, which keeps it out of the accessibility
 * tree — pass `decorative={false}` only when the line genuinely separates two
 * groups a screen-reader user needs to know are separate.
 */
export function Separator({ className, orientation = 'horizontal', ...props }: SeparatorProps) {
  return (
    <Root
      orientation={orientation}
      className={cn(
        'shrink-0 bg-line',
        orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px',
        className,
      )}
      {...props}
    />
  );
}
